import { OPEN_ORDER_DRAWER_SCAN_ACTION_NAME } from '../constants/scanActionNames.const';
import { type ScanAction, type ScanActionResult } from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';

export const createOpenOrderDrawerScanAction = (): ScanAction => ({
  // TODO: QPACK-460: Implement the logic to submit the order details drawer.
  execute: (scanEvent: ScanEvent): ScanActionResult => {
    // eslint-disable-next-line no-console
    console.debug('Executed Action: OpenOrderDrawerScanAction', scanEvent);
    return { success: true };
  },

  // TODO: QPACK-460: Implement the logic to submit the order details drawer.
  matches: () => false,

  name: OPEN_ORDER_DRAWER_SCAN_ACTION_NAME,
});
